import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/turn-circle.svg'
import _imports_1 from '@/assets/icons/chevron-down-circle.svg'
import _imports_2 from '@/assets/icons/place-filled.svg'
import _imports_3 from '@/assets/icons/parking.svg'
import _imports_4 from '@/assets/icons/bus_bell-on.svg'
import _imports_5 from '@/assets/icons/bus_bell-off.svg'


const _withScopeId = n => (_pushScopeId("data-v-51e8f993"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bus-location-wrapper" }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "bus-route" }
const _hoisted_4 = {
  key: 0,
  class: "bus-route--top"
}
const _hoisted_5 = {
  key: 1,
  class: "turn-icon",
  src: _imports_0,
  alt: "회차"
}
const _hoisted_6 = {
  key: 2,
  class: "chevron-down",
  src: _imports_1,
  alt: "아래 화살표"
}
const _hoisted_7 = {
  key: 3,
  class: "bus-route--bottom"
}
const _hoisted_8 = { class: "bus-stop-info-wrapper" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "bus-stop-info" }
const _hoisted_11 = { class: "bus-stop-type-name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-divider" }, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bus-stop-location-icon",
  src: _imports_2,
  alt: "위치"
}, null, -1 /* HOISTED */))
const _hoisted_14 = {
  key: 2,
  src: _imports_3,
  alt: "주차장"
}
const _hoisted_15 = {
  key: 0,
  class: "info"
}
const _hoisted_16 = {
  key: 0,
  class: "prefix-svg"
}
const _hoisted_17 = {
  key: 2,
  class: "omitted-bus-stop-description"
}
const _hoisted_18 = {
  key: 3,
  class: "temp-bus-stop-description"
}
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = {
  key: 0,
  src: _imports_4,
  alt: "하차벨 켜짐",
  "aria-hidden": "true"
}
const _hoisted_21 = {
  key: 1,
  src: _imports_5,
  alt: "하차벨 꺼짐",
  "aria-hidden": "true"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["aria-label"]
const _hoisted_24 = {
  key: 1,
  class: "arrow-wrapper"
}
const _hoisted_25 = {
  key: 0,
  class: "arrow-start"
}
const _hoisted_26 = {
  key: 1,
  class: "arrow-middle"
}
const _hoisted_27 = {
  key: 2,
  class: "arrow-end"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow-shaft" }, null, -1 /* HOISTED */))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow down" }, null, -1 /* HOISTED */))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bus-stop-row-wapper", {
      'show-in-main-card': $props.showInMainCard,
      'show-remainig-time': $setup.shouldShowRemainigTime,
    }]),
    "aria-label": `정류장: ${$props.busStop.name}`
  }, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.busLocationsMap.entries(), ([key, locations], index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        ($setup.isBusStopEventExisted(key))
          ? (_openBlock(), _createBlock($setup["BusLocationIndicator"], {
              key: 0,
              busStopEventCode: key,
              showInMainCard: $props.showInMainCard,
              busLocations: locations,
              selectedBus: $props.selectedBus,
              allBusesMap: $props.allBusesMap,
              busStop: $props.busStop,
              isInsideShuttle: $props.isInsideShuttle,
              onOnClickBubble: $setup.emitOnClickBubble,
              onOnClickBusIcon: $setup.emitOnClickBusIcon
            }, null, 8 /* PROPS */, ["busStopEventCode", "showInMainCard", "busLocations", "selectedBus", "allBusesMap", "busStop", "isInsideShuttle"]))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_3, [
      ($props.index !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("v-if", true),
      ($props.busStop.isReturnStop)
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : (_openBlock(), _createElementBlock("img", _hoisted_6)),
      (!$props.isLastRow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "bus-stop-infos",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emitOnClickBusStopLocation($props.busStop))),
        "aria-label": `정류장 위치 보기: ${$props.busStop.name}`
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createCommentVNode("  '즐겨찾기(별) 버튼' + '승차 | 하차 텍스트'  "),
          (!$props.shouldShowBusStopLocation && !$props.isInsideShuttle && !$props.isBookable)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode($setup["FavoriteStatusButton"], {
                  shouldBeFilled: $setup.isFavoriteBusStop,
                  class: _normalizeClass({ invisible: $props.busStop.isPassByStop() }),
                  favoritedIcon: require('@/assets/icons/bell-on.svg'),
                  unFavoritedIcon: require('@/assets/icons/bell-off.svg'),
                  onOnClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emitOnClickFavoriteStatusButton($props.busStop)))
                }, null, 8 /* PROPS */, ["shouldBeFilled", "class", "favoritedIcon", "unFavoritedIcon"]),
                _createElementVNode("span", _hoisted_11, _toDisplayString($setup.busStopTypeName), 1 /* TEXT */),
                _hoisted_12
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" '위치' 아이콘 "),
                _hoisted_13
              ], 64 /* STABLE_FRAGMENT */)),
          _createCommentVNode(" 정류장 이름 "),
          ($props.busStop.shouldShowBusStopLayout)
            ? (_openBlock(), _createElementBlock("img", _hoisted_14))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", {
            class: _normalizeClass({ disabled: $setup.disable })
          }, _toDisplayString($props.busStop.name), 3 /* TEXT, CLASS */)
        ]),
        _createCommentVNode(" 목표도착시각, TMAP예상도착시각 등 표시 "),
        _createElementVNode("div", {
          class: _normalizeClass(["bus-stop-info more", {
            disabled: $setup.disable,
            padding: !$props.isInsideShuttle,
            'show-bus-stop-location': $props.shouldShowBusStopLocation,
          }])
        }, [
          (!$props.isInsideShuttle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                ($setup.shouldShowPrefixSvg && $setup.props.arrivalTimesForDisplay)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createVNode($setup["InlineSvg"], {
                        src: $setup.props.arrivalTimesForDisplay.prefix
                      }, null, 8 /* PROPS */, ["src"])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["bus-stop-time", { prefix: $setup.shouldShowPrefixSvg }])
                }, _toDisplayString($setup.busStopTimeText), 3 /* TEXT, CLASS */)
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.shouldShowRemainigTime)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["remaining-time", { 'no-info': !$setup.arrivalTimeRemaining }])
              }, _toDisplayString($setup.arrivalTimeRemaining), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 미경유 정류장의 경우 "),
          ($props.busStop.isOmitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("p", null, _toDisplayString(`${$setup.detourEndDisplayText}까지 미경유`), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 임시 정류장의 경우 "),
          ($props.busStop.isTemp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("p", null, _toDisplayString(`${$setup.detourEndDisplayText}까지 임시정류장 운영`), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 환승 정류장 "),
          ($props.busStop.transferBusStops?.length)
            ? (_openBlock(), _createBlock($setup["TransferBusStop"], {
                key: 4,
                transferBusStops: $props.busStop.transferBusStops,
                transferGuide: $props.busStop.transferGuide
              }, null, 8 /* PROPS */, ["transferBusStops", "transferGuide"]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 정류장 변경(추가/폐지) 예정 문구 표시 "),
          ($setup.shouldShowBusStopChangeTextAndModal)
            ? (_openBlock(), _createBlock($setup["BusStopChangeTextAndModal"], {
                key: 5,
                busStop: $props.busStop,
                isInsideShuttle: $props.isInsideShuttle,
                isBookable: $props.isBookable
              }, null, 8 /* PROPS */, ["busStop", "isInsideShuttle", "isBookable"]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ], 8 /* PROPS */, _hoisted_9),
      _createCommentVNode(" 사내셔틀 시간표 "),
      _createCommentVNode(" <button\n        v-if=\"isInsideShuttle\"\n        class=\"btn-schedule\"\n        @click=\"emitOnClickScheduleBtn(busStop)\"\n      >\n        시간표\n      </button> "),
      ($props.shouldShowGetOffBell && $props.busStop.isGetOffStop && $props.isOnBoarding)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(["btn-bell", { active: $props.activatedGetOffBell }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.emitOnClickGetOffBell(!$props.activatedGetOffBell))),
            "aria-label": $props.activatedGetOffBell ? '하차벨 끄기' : '하차벨 켜기'
          }, [
            ($props.activatedGetOffBell)
              ? (_openBlock(), _createElementBlock("img", _hoisted_20))
              : (_openBlock(), _createElementBlock("img", _hoisted_21))
          ], 10 /* CLASS, PROPS */, _hoisted_19))
        : _createCommentVNode("v-if", true)
    ]),
    (!$props.showInMainCard && !$props.isInsideShuttle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          ($setup.showButton && $props.isBookable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                ref: "selectButton",
                type: "button",
                class: _normalizeClass(["btn-select", { chip: !$props.isBookable }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleSelectBusStop($event.clientY))),
                "aria-label": $setup.buttonTitle
              }, _toDisplayString($setup.buttonTitle), 11 /* TEXT, CLASS, PROPS */, _hoisted_23))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.selectComplete && !$props.isInsideShuttle && $props.isBookable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          ($setup.showArrowStart)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25))
            : _createCommentVNode("v-if", true),
          ($setup.showArrowMiddle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26))
            : _createCommentVNode("v-if", true),
          ($setup.showArrowEnd)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [..._hoisted_30]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}